import BaseService from 'services/BaseService';
import { LatestResponse, ProposedAction } from 'pages/MetaAdsInsights/types';

export const DEFAULT_ACCOUNT_ID = '2599873303368305'; // Dosaze

class MetaAdsInsightsService extends BaseService {
  basePath = 'v1/meta-ads-insights';

  async getLatest(accountId = DEFAULT_ACCOUNT_ID) {
    await this._getAccessToken();
    return this.handleHttpRequest<LatestResponse>(
      () =>
        this.http.get(`${this.basePath}/snapshots/latest`, {
          params: { account_id: accountId },
        }),
      'Failed to load Meta Ads snapshot',
    );
  }

  async requestRefresh(requestedBy: string, accountId = DEFAULT_ACCOUNT_ID) {
    await this._getAccessToken();
    return this.handleHttpRequest<{ status: string }>(
      () =>
        this.http.post(
          `${this.basePath}/refresh`,
          { requested_by: requestedBy },
          { params: { account_id: accountId } },
        ),
      'Failed to request refresh',
    );
  }

  async listActions(status?: string, accountId = DEFAULT_ACCOUNT_ID) {
    await this._getAccessToken();
    return this.handleHttpRequest<{ actions: ProposedAction[] }>(
      () =>
        this.http.get(`${this.basePath}/actions`, {
          params: { account_id: accountId, status },
        }),
      'Failed to list Meta Ads actions',
    );
  }

  async approveAction(
    actionId: string,
    approverEmail: string,
    params?: Record<string, unknown>,
    accountId = DEFAULT_ACCOUNT_ID,
  ) {
    await this._getAccessToken();
    return this.handleHttpRequest<ProposedAction>(
      () =>
        this.http.post(
          `${this.basePath}/actions/${encodeURIComponent(actionId)}/approve`,
          { approver_email: approverEmail, params },
          { params: { account_id: accountId } },
        ),
      'Failed to approve action',
    );
  }

  async rejectAction(
    actionId: string,
    approverEmail: string,
    reason?: string,
    accountId = DEFAULT_ACCOUNT_ID,
  ) {
    await this._getAccessToken();
    return this.handleHttpRequest<ProposedAction>(
      () =>
        this.http.post(
          `${this.basePath}/actions/${encodeURIComponent(actionId)}/reject`,
          { approver_email: approverEmail, reason },
          { params: { account_id: accountId } },
        ),
      'Failed to reject action',
    );
  }
}

export default MetaAdsInsightsService;
